export default __webpack_public_path__ + "static/media/avatar-dennis.2d6b046f.png";